import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Échec de l\'authentification');
        const data = await res.json();
        await refresh();
        // Clear hash and redirect
        window.history.replaceState(null, '', '/');
        toast.success(`Bienvenue ${data.user?.name || ''} 👋`);
        navigate('/', { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error(e);
        toast.error('Erreur de connexion : ' + (e.message || e));
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      width: '100vw', height: '100vh', background: '#0a0a0d', color: '#f0f0f5',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner" style={{
          width: 40, height: 40, borderRadius: '50%',
          border: '3px solid #2a2a32', borderTop: '3px solid #ec1d8c',
          animation: 'spin 1s linear infinite', margin: '0 auto 16px',
        }} />
        <div>Authentification en cours…</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
